import { i18n } from '@src/i18n-setup';
import { SortFieldEnum } from '@utils/offer/sort-offers';

/**
 * Handy object to be passed to the ld-sorting-header component.
 *
 * @return {Object} The processed object to use
 */
export default function getSortingHeaderData() {
  return {
    options: [
      {
        key: SortFieldEnum.LENDER_NAME,
        value: i18n.t('dashboard.sorting_header.lender'),
      },
      {
        key: SortFieldEnum.RATE_TYPE,
        value: i18n.t('dashboard.sorting_header.rate_type'),
      },
      {
        key: SortFieldEnum.INTEREST_RATE,
        value: i18n.t('dashboard.sorting_header.interest_rate'),
      },
      {
        key: SortFieldEnum.COMPARISON_RATE,
        value: i18n.t('dashboard.sorting_header.comparision_rate'),
        tooltip: i18n.t('dashboard.sorting_header.comparision_rate_tooltip'),
      },
      {
        key: SortFieldEnum.REPAYMENT,
        value: i18n.t('dashboard.sorting_header.monthly_repayment'),
      },
      {
        value: i18n.t('dashboard.sorting_header.features'),
        sortable: false,
      },
    ],
  };
}
